import NavBar from "../Navbar/Navbar";
import SideBar from "../Sidebar/SideBar";
import "./School-District.css";
import PropTypes from "prop-types";
import { Link, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { visuallyHidden } from "@mui/utils";
import {
  editTeacherDetails,
  getSchoolById,
  getAllSchoolTeachers,
  deleteTeacherDetails,
  InviteSchoolTeacher,
  passwordChangeTeacher,
  createFullNewTeacher,
} from "./api";
import getCookie, { districtAdminState, setDistrictCookie } from "../../Atom";
import CustomModal from "../Modal/CusModal";
import { CircularProgress } from "@material-ui/core";
import { Modal, Button } from "react-bootstrap";
import Popup from "../popup/Popup";
import {
  AssignDevice,
  DeleteAssignedDevice,
  getAllAssignedDevicesForTeacher,
  SpareAssignedDevicesTeacher,
} from "../ManageTeacherDevice/api";
import Tooltip from "@mui/material/Tooltip";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Dialog from "@mui/material/Dialog";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";

import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Tabs,
  Tab,
} from "@mui/material";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const headCells = [
  {
    id: "_id",
    numeric: false,
    disablePadding: true,
    label: "Id",
  },
  {
    id: "fName",
    numeric: false,
    disablePadding: true,
    label: "Class Teacher",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },
  {
    id: "manage",
    numeric: false,
    disablePadding: true,
    label: "Manage",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              sx={{ display: "flex" }}
              className=" mb-2"
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="div" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
              
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    //
    <div className="pt-10"></div>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function School({ match }) {
  const newTeacherPopup = useRef();
  const history = useHistory();
  let search = window.location.search;
  let paramse = new URLSearchParams(search);
  const schoolId = match.params.id;
  const [myUser, setmyUser] = useState();
  const [schoolDetails, setSchoolDetails] = useState({});
  const [teachers, setTeachers] = useState([]);
  const [deletedTeachers, setDeletedTeachers] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fname, setfName] = useState("");
  const [lname, setlName] = useState("");
  const [teacherDetails, setteacherDetails] = useState(null);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [teacherId, setTeacherId] = useState("");
  const [show, setShow] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [deviceShow, setDeviceShow] = useState(false);
  const [password, setPassword] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [currDelPage, setDelCurrPage] = useState(0);
  const [paged, setPaged] = useState(0);
  const [delPaged, setdelPaged] = useState(0);
  const [noOfPages, setNoOfPages] = useState(0);
  const [noOfDelPages, setNoOfDelPages] = useState(0);
  const [tLimit, setTLimit] = useState(25);
  const [tPage, setTPage] = React.useState(0);
  const [tOrder, setTOrder] = React.useState("desc");
  const [tOrderBy, setTOrderBy] = React.useState("createdAt");
  const [delTPage, setdelTPage] = React.useState(0);
  const [delTLimit, setDelTLimit] = React.useState(25);
  const [delTOrder, setdelTOrder] = React.useState("desc");
  const [delTOrderBy, setDelTOrderBy] = React.useState("createdAt");
  const [selected, setSelected] = React.useState([]);
  const [dense, setDense] = React.useState(false);
  const [tRowsPerPage, setTRowsPerPage] = React.useState(tLimit);
  const [delTRowsPerPage, setdelTRowsPerPage] = React.useState(delTLimit);
  let params = useParams();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [dataNewTeacher, setDataNewTeacher] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
  });

  const [adminTouched, setAdminTouched] = useState({
    fName: false,
    lName: false,
    email: false,
    password: false,
  });

  const emailRegex =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  let { districtId, id } = params;

  const allDevicesModal = useRef();
  const [deviceType, setDeviceType] = useState(1);
  const [devices, setDevices] = useState({ assigned: [], spare: [] });

  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");

  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setDistrictCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      ////console.loghostname,window.location.protocol)
      window.location.assign(
        `${window.location.protocol}//${hostname}/school-district`
      );
    });
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["district_admin_v1"];
      setmyUser(user);
      let urltPage = parseInt(paramse.get("tPage")) || 0;
      let urltLimit = parseInt(paramse.get("tLimit")) || tLimit;
      let urldelTPage = parseInt(paramse.get("delTpage")) || 0;
      let urldelTLimit = parseInt(paramse.get("delTlimit")) || delTLimit;
      let urlTOrderBy = paramse.get("tOrderBy");
      let urlTOrder = paramse.get("tOrder");
      let urldelTOrderBy = paramse.get("delTorderBy");
      let urldelTOrder = paramse.get("delTorder");
      if (parseInt(paramse.get("page"))) {
        history.push({
          pathname: `/schools/${schoolId}`,
          search: "?tPage="+urltPage+'&tLimit='+urltLimit+'&tOrderBy='+ urlTOrderBy+'&tOrder='+urlTOrder+'&delTpage='+urldelTPage+'&delTLimit='+urldelTLimit+'&delTOrderBy='+urldelTOrderBy+'&delTOrder='+urldelTOrder  ,
        });
        getSchool(urltPage, urltLimit,urlTOrderBy,urlTOrder,urldelTPage,urldelTLimit,urlTOrderBy,urlTOrder, user);
        setTPage(urltPage);
        setdelTPage(urldelTPage);
      } else {
        setTPage(0);
        setdelTPage(0);
        history.push({
          pathname: `/schools/${schoolId}`,
          search: `?tPage=${tPage}&tLimit=${tLimit}&tOrderBy=${tOrderBy}&tOrder=${tOrder}&delTpage=${delTPage}&delTLimit=${delTLimit}&delTOrderBy=${delTOrderBy}&delTOrder=${delTOrder}`,
        });
        getSchool(0, tLimit,tOrderBy,tOrder,0,delTLimit,delTOrderBy,delTOrder, user);
      }
      getAssignedDevicesForTeachers(user);
    }
  }, []);

  const getSchool = async (tPage, tLimit,tOrderBy,tOrder,delTPage,delTLimit,delTOrderBy,delTOrder, user = myUser) => {
    let res = await getSchoolById(user?.token, districtId, id);
    let res1 = await getAllSchoolTeachers(schoolId, user?.token,tPage, tLimit,tOrderBy,tOrder,delTPage,delTLimit,delTOrderBy,delTOrder);
    ////console.logparams)

    if (res?.error) {
      // alert('Error fetching schools. Try Again')
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      setTeachers(res1?.res?.data?.data?.teachers);
      setSchoolDetails(res?.res?.data?.data?.school);
      setDeletedTeachers(res1?.res?.data?.data?.deletedTeachers);
      let divisor = parseInt(res1?.res?.data?.data?.totalTeachercount / tLimit);
      let remainder =
        res1?.res?.data?.data?.totalTeachercount % tLimit == 0 ? 0 : 1;
        let divisorDel = parseInt(res1?.res?.data?.data?.totalDeletedTeachercount / delTLimit);
        let remainderDel =
          res1?.res?.data?.data?.totalDeletedTeachercount % delTLimit == 0 ? 0 : 1;
      setNoOfPages(divisor + remainder);
      setNoOfDelPages(divisorDel+remainderDel)
      setCurrPage(tPage);
      setDelCurrPage(delTPage)
    }
  };

  const ManageModal = (id) => {
    setTeacherId(id);
    setShowManage(true);
  };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setDeleteMode(false);
    setEditMode(false);
    setteacherDetails(null);
  };

  const handleShowAddModal = () => {
    setShowAddModal(true);
  };

  const sendMail = async () => {
    setLoading(true);
    let data = { email: email, message: message };
    let ids = { did: districtId, sid: id };
    let res = await InviteSchoolTeacher(schoolId, myUser.token, data);
    if (!res?.error) {
      setLoading(false);
      // alert('Mail Sent')
      feedBackMsg(true, "success", res?.res?.data?.msg);
      handleClose();
    } else {
      setLoading(false);
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
      // alert('Failed sending mail. try Again')
    }
    ////console.logres);
  };

  const editTeacher = async () => {
    let ids = { did: districtId, sid: id, teacherid: teacherDetails._id };
    let data = {
      fName: fname.trim(),
      lName: lname.trim(),
      email: email.trim(),
    };
    let res;
    if (editMode) {
      res = await editTeacherDetails(
        teacherDetails._id,
        schoolId,
        myUser.token,
        data
      );
    } else {
      res = await deleteTeacherDetails(
        teacherDetails._id,
        schoolId,
        myUser.token
      );
    }

    if (!res.error) {
      ////console.logres)
      // alert('Teacher Details Editted')
      feedBackMsg(true, "success", res.res.data.msg);
      history.replace({
        pathname: `/schools/${schoolId}`,
        search: `?tPage=${tPage}&tLimit=${tLimit}&tOrderBy=${tOrderBy}&tOrder=${tOrder}&delTpage=${delTPage}&delTLimit=${delTLimit}&delTOrderBy=${delTOrderBy}&delTOrder=${delTOrder}`,
      });
      getSchool(tPage,tLimit,tOrderBy,tOrder,delTPage,delTLimit,delTOrderBy,delTOrder);
      handleCloseAddModal();
    } else {
      setLoading(false);
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
      // alert('Failed to perform this operation. Try Again')
    }
  };

  const showEditModal = async (teacherid, teach, type) => {
    // let res = await getTeacherDetails(teacherid,schoolId, myUser.token);
    if (type == "edit") setEditMode(true);
    else setDeleteMode(true);
    setteacherDetails(teach);
    setfName(teach.fName);
    setlName(teach.lName);
    setEmail(teach.email);
    handleShowAddModal();
  };

  const passwordChanges = async () => {
    ////console.logid, teacherId);
    let ids = { sid: id, teacherid: teacherId };
    let data = { email: email, password: password };
    // let data={email:'john2@mailinator.com',password:'pass'};
    let res = await passwordChangeTeacher(
      ids.teacherid,
      ids.sid,
      data,
      myUser.token
    );
    if (!res.error) {
      ////console.logres)
      alert(res.res.data.msg);
      history.push({
        pathname: `/schools/${schoolId}`,
        search: `?tPage=${tPage}&tLimit=${tLimit}&tOrderBy=${tOrderBy}&tOrder=${tOrder}&delTpage=${delTPage}&delTLimit=${delTLimit}&delTOrderBy=${delTOrderBy}&delTOrder=${delTOrder}`,
      });
      getSchool(tLimit,tOrderBy,tOrder,delTPage,delTLimit,delTOrderBy,delTOrder);
      feedBackMsg(true, "success", res.res.data.msg);
    } else {
      setLoading(false);
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
      // alert('failed for changing password. Try Again')
    }
    handleClose();
  };

  const handleClose = () => {
    setShow(false);
    setEditPassword("");
    setteacherDetails(null);
    setfName("");
    setlName("");
    setEmail("");
  };
  const handleShow = () => setShow(true);
  const [showManage, setShowManage] = useState(false);
  const handleShowManageDevice = () => {
    setShowManage(false);
  };

  const assignThisDeviceToTeacher = async (deviceId) => {
    let res = await AssignDevice(schoolId, teacherId, deviceId, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      feedBackMsg(true, "success", res.res.data.msg);
    }
    ////console.logres)
    getAssignedDevicesForTeachers();
  };

  const unassignThisDeviceToTeacher = async (device) => {
    let deviceHistoryId;
    let found = false;
    let items = device.assigneeDetails.teacher;
    for (let i = 0; i < items.length && !found; i++) {
      if (items[i].teacherId == teacherId) {
        deviceHistoryId = items[i].historyId;
        found = true;
      }
    }
    let res = await DeleteAssignedDevice(
      schoolId,
      teacherId,
      device._id,
      deviceHistoryId,
      myUser.token
    );
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      feedBackMsg(true, "success", res.res.data.msg);
    }
    getAssignedDevicesForTeachers();
  };

  const getAssignedDevicesForTeachers = async (user = myUser) => {
    ////console.logteacherId)
    if (teacherId) {
      ////console.logteacherId);
      let res = await getAllAssignedDevicesForTeacher(
        schoolId,
        teacherId,
        user?.token
      );
      let res1 = await SpareAssignedDevicesTeacher(
        schoolId,
        teacherId,
        user?.token
      );
      if (res.error) {
        if (res.data.statusCode == 401) {
          logoutHandler();
        } else {
          feedBackMsg(true, "error", res.data.msg);
        }
      } else {
        feedBackMsg(true, "success", res.res.data.msg);
      }
      // for(let i=0;i<25;i++){
      //   res.res.data.data.devices=[res.res.data.data.devices,...res.res.data.data.devices]
      //   res1.res.data.data.devices=[res1.res.data.data.devices,...res1.res.data.data.devices]
      // }
      ////console.logres.res.data.data.devices,res1.res.data.data.devices)
      setDevices({
        assigned: res.res.data.data.devices,
        spare: res1.res.data.data.devices,
      });
    }
  };

  const getAssignedDevicesForTeachers1 = async (teacherId) => {
    ////console.logteacherId)
    if (teacherId) {
      ////console.logteacherId);
      let res = await getAllAssignedDevicesForTeacher(
        schoolId,
        teacherId,
        myUser.token
      );
      let res1 = await SpareAssignedDevicesTeacher(
        schoolId,
        teacherId,
        myUser.token
      );
      if (res.error) {
        if (res.data.statusCode == 401) {
          logoutHandler();
        } else {
          feedBackMsg(true, "error", res.data.msg);
        }
      } else {
        feedBackMsg(true, "success", res.res.data.msg);
      }
      ////console.logres.res.data.data.devices[0].name)
      setDevices({
        assigned: res.res.data.data.devices,
        spare: res1.res.data.data.devices,
      });
    }
  };

  const handleCreateFullNewTeacher = async (e) => {
    e.preventDefault();
     const res = await createFullNewTeacher(id, dataNewTeacher, myUser.token);
    if (!res?.error) {
      history.replace({
        pathname: `/schools/${schoolId}`,
        search: `?tPage=${tPage}&tLimit=${tLimit}&tOrderBy=${tOrderBy}&tOrder=${tOrder}&delTpage=${delTPage}&delTLimit=${delTLimit}&delTOrderBy=${delTOrderBy}&delTOrder=${delTOrder}`,
      });
      getSchool(tPage,tLimit,tOrderBy,tOrder,delTPage,delTLimit,delTOrderBy,delTOrder);
      newTeacherPopup.current.close();
      feedBackMsg(true, "success", res?.res?.data?.msg);
    } else {
      // alert('Could not create Teacher ')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    }
    setAdminTouched({
      fName: false,
      lName: false,
      email: false,
      password: false,
      mobile: false,
    });

    setDataNewTeacher({
      fName: "",
      lName: "",
      email: "",
      password: "",
      mobile: "",
    });
  };

  const prepareDeviceBox = (teacherId) => {
    setTeacherId(teacherId);
    ////console.logteacherId)
    getAssignedDevicesForTeachers();
    // allDevicesModal.current.open()
    setDeviceShow(true);
  };

  const handleChangePage = (event, newPage) => {
      let urltLimit = parseInt(paramse.get("tLimit")) || tLimit;
      let urldelTPage = parseInt(paramse.get("delTpage")) || 0;
      let urldelTLimit = parseInt(paramse.get("delTlimit")) || delTLimit;
      let urlTOrderBy = paramse.get("tOrderBy");
      let urlTOrder = paramse.get("tOrder");
      let urldelTOrderBy = paramse.get("delTorderBy");
      let urldelTOrder = paramse.get("delTorder");
    setTPage(event.selected);
    history.push({
      pathname: `/schools/${schoolId}`,
      search: `?tPage=${event.selected}&tLimit=${urltLimit}&tOrderBy=${urlTOrderBy}&tOrder=${urlTOrder}&delTpage=${urldelTPage}&delTLimit=${urldelTLimit}&delTOrderBy=${urldelTOrderBy}&delTOrder=${urldelTOrder}`,
    });
    getSchool(event.selected,urltLimit,urlTOrderBy,urlTOrder,urldelTPage,urldelTLimit,urldelTOrderBy,urldelTOrder);
  };
  const handleChangeDelPage = (event, newPage) => {
    let urltPage = parseInt(paramse.get("tPage")) || tPage;
    let urltLimit = parseInt(paramse.get("tLimit")) || tLimit;
    let urldelTPage = parseInt(paramse.get("delTpage")) || 0;
    let urldelTLimit = parseInt(paramse.get("delTlimit")) || delTLimit;
    let urlTOrderBy = paramse.get("tOrderBy");
    let urlTOrder = paramse.get("tOrder");
    let urldelTOrderBy = paramse.get("delTorderBy");
    let urldelTOrder = paramse.get("delTorder");
    setdelPaged(event.selected);
    getSchool(urltPage,urltLimit,urlTOrderBy,urlTOrder,event.selected,urldelTLimit,urldelTOrderBy,urldelTOrder);
    history.push({
      pathname: `/schools/${schoolId}`,
      search: `?tPage=${urltPage}&tLimit=${urltLimit}&tOrderBy=${urlTOrderBy}&tOrder=${urlTOrder}&delTpage=${event.selected}&delTLimit=${urldelTLimit}&delTOrderBy=${urldelTOrderBy}&delTOrder=${urldelTOrder}`,
    });
  };
  const passwordChange = (id, email) => {
    setTeacherId(id);
    setEditPassword(true);
    setEmail(email);
    handleShow();
  };

  const handleCloseDevice = () => {
    setDeviceShow(false);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = teachers.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const onSetOrder = (event, property) => {
    var orderTemp = value 
  ? (delTOrder === "asc" ? "desc" : "asc") 
  : (tOrder === "asc" ? "desc" : "asc");
    var urltPage = parseInt(paramse.get("tPage")) || 0;
    var urltLimit = parseInt(paramse.get("tLimit")) || tLimit;
    var urldelTPage = parseInt(paramse.get("delTpage")) || 0;
    var urldelTLimit = parseInt(paramse.get("delTlimit")) || delTLimit;
    let urlTOrderBy = paramse.get("tOrderBy");
      let urlTOrder = paramse.get("tOrder");
      let urldelTOrderBy = paramse.get("delTorderBy");
      let urldelTOrder = paramse.get("delTorder");
    if(value){
      setDelTOrderBy(property);
      setdelTOrder(orderTemp);
      history.push({
        pathname: `/schools/${schoolId}`,
        search: "?tPage="+urltPage+'&tLimit='+urltLimit+'&tOrderBy='+urlTOrderBy+'&tOrder='+urlTOrder+'&delTpage='+urldelTPage+'&delTLimit='+urldelTLimit+'&delTOrderBy='+property+'&delTOrder='+orderTemp,
      });
      getSchool(urltPage, urltLimit,property,orderTemp,urldelTPage,urldelTLimit,urlTOrderBy,urlTOrder);
    }else{
      setTOrderBy(property);
      setTOrder(orderTemp);
      history.push({
        pathname: `/schools/${schoolId}`,
        search: "?tPage="+urltPage+'&tLimit='+urltLimit+'&tOrderBy='+property+'&tOrder='+orderTemp+'&delTpage='+urldelTPage+'&delTLimit='+urldelTLimit+'&delTOrderBy='+urldelTOrderBy+'&delTOrder='+urldelTOrder,
      });
      getSchool(urltPage, urltLimit,property,orderTemp,urldelTPage,urldelTLimit,urlTOrderBy,urlTOrder);
    }
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const teacherValidation = () => {
    if (
      dataNewTeacher.fName.trim() == "" ||
      dataNewTeacher.fName == null ||
      dataNewTeacher.lName.trim() == "" ||
      dataNewTeacher.lName == null ||
      dataNewTeacher.email.trim() == "" ||
      dataNewTeacher.email == null ||
      !emailRegex.test(dataNewTeacher.email) ||
      dataNewTeacher.password.trim() == "" ||
      dataNewTeacher.password == null ||
      dataNewTeacher.password.length < 7
    ) {
      return false;
    } else {
      return true;
    }
  };
  const emptyRows =tPage > 0 ? Math.max(0, (1 + tPage) * tRowsPerPage - teachers.length) : 0;
  const emptyRowsDelT =delTPage > 0 ? Math.max(0, (1 + delTPage) * delTRowsPerPage - teachers.length) : 0;
  return (
    <section id="hero-school ">
      <Dialog open={deviceShow} fullWidth onClose={handleCloseDevice}>
        <DialogTitle>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h6" style={{ fontWeight: "600" }}>
              Manage Devices
            </Typography>
            <IconButton onClick={handleCloseDevice}>
              <CloseIcon
                style={{ border: "2px solid black", fontSize: "30px" }}
              />
            </IconButton>
          </Grid>
        </DialogTitle>
        <div style={{ minHeight: "275px", margin: "0 10%", overflow: "auto" }}>
          <div className="d-flex justify-content-center">
            <button
              className="tab-btn"
              style={{
                backgroundColor: deviceType === 1 ? "#4196EB" : "#fff",
                color: deviceType === 1 ? "#fff" : "#000",
              }}
              onClick={() => setDeviceType(1)}
            >
              Allocated Devices
            </button>
            <button
              className="tab-btn"
              style={{
                backgroundColor: deviceType === 2 ? "#4196EB" : "#fff",
                color: deviceType === 2 ? "#fff" : "#000",
              }}
              onClick={() => setDeviceType(2)}
            >
              Available Devices
            </button>
          </div>
          {deviceType === 2 &&
            devices.spare.map((item) => {
              return (
                <div className="devices-table" key={item._id}>
                  <td style={{ fontWeight: "600" }}>{item.name}</td>
                  <td>
                    <button
                      className="assign-btn"
                      onClick={() => assignThisDeviceToTeacher(item._id)}
                    >
                      Assign
                    </button>
                  </td>
                </div>
              );
            })}
          {deviceType === 1 &&
            devices.assigned.map((item) => {
              if (item.teacher.includes(teacherId)) {
                return (
                  <div className="devices-table" key={item._id}>
                    <td style={{ fontWeight: "600" }}>{item.name}</td>
                    <td>
                      <button
                        className="unassign-btn"
                        onClick={() => unassignThisDeviceToTeacher(item)}
                      >
                        Remove
                      </button>
                    </td>
                  </div>
                );
              }
            })}
        </div>
      </Dialog>
      <CustomModal handleClose={handleCloseAddModal} show={showAddModal}>
        <section id="hero-Msd">
          <div className="row main-div-modal">
            <div className="col-md-6 m-auto center-div text-center">
              <div className="p-2 center-div">
                <h2>
                  <button
                    onClick={handleCloseAddModal}
                    className="btn close-btn  rounded-circle float-right"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="20" cy="20" r="20" fill="#011627" />
                      <path
                        d="M27.0693 13.1005L12.9272 27.2426"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M27.0693 27.2426L12.9272 13.1005"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </h2>
                {editMode ? (
                  <>
                    <div className="mt-3">
                      <h6>Edit Teacher</h6>
                    </div>
                    <div className="col-md-7 text-left col-9 m-auto">
                      <div className="form-group mt-4   p-20">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="First Name"
                          value={fname}
                          onChange={(e) => setfName(e.target.value)}
                          onBlur={(e) => setfName(e.target.value.trim())}
                        />
                      </div>
                      <div className="form-group mt-4   p-20">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Last Name"
                          value={lname}
                          onBlur={(e) => setlName(e.target.value.trim())}
                          onChange={(e) => setlName(e.target.value)}
                        />
                      </div>
                      <div className="form-group mt-4   p-20">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Email"
                          value={email}
                          onBlur={(e) => setEmail(e.target.value.trim())}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="cta-btn"
                          onClick={editTeacher}
                        >
                          {loading ? <CircularProgress /> : "Edit"}
                        </button>
                      </div>
                    </div>
                  </>
                ) : deleteMode ? (
                  <>
                    <div className="mt-3">
                      <h6>Delete Teacher</h6>
                    </div>
                    <div className="col-md-7 text-left col-9 m-auto">
                      <br />
                      <h6>
                        Remember that this action is irreversible. Once the
                        teacher is removed, you cannot re-instate it.
                      </h6>
                      <h5>Are you sure to remove this Teacher?</h5>

                      <div className="form-group mt-4   p-20">
                        <input
                          type="text"
                          readOnly
                          className="form-control"
                          placeholder="First Name"
                          value={
                            teacherDetails?.fName + " " + teacherDetails?.lName
                          }
                        />
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="cta-btn-red"
                          onClick={editTeacher}
                        >
                          {loading ? <CircularProgress /> : "Remove"}
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </section>
      </CustomModal>
      <Modal show={show} onHide={handleClose}>
        {editPassword ? (
          <>
            <Modal.Header closeButton>
              <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group mt-4 p-20">
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  onBlur={(e) => setPassword(e.target.value.trim())}
                />
                <span style={{ color: "red" }}>
                  Password should be atleast 8 characters
                </span>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={passwordChanges}
                disabled={password.trim().length < 8}
              >
                Change Password
              </Button>
            </Modal.Footer>
          </>
        ) : (
          <>
            <Modal.Header closeButton>
              <Modal.Title>Invite Teacher</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    value={email}
                    className="form-control"
                    placeholder="Email"
                    onBlur={(e) => setEmail(e.target.value.trim())}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    value={message}
                    className="form-control"
                    placeholder="Message"
                    onBlur={(e) => setMessage(e.target.value)}
                    onChange={(e) => setMessage(e.target.value.trim())}
                  />
                </div>
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={sendMail}>
                Send Request
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
      <div className="h-100  ">
        <NavBar />
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to={"/schools"}>
            School
          </Link>
          <Typography color="text.primary">Teacher</Typography>
          {/* <Link underline="hover" color="inherit" href="/">Breadcrumbs</Link> */}
        </Breadcrumbs>
        <div className="dashboard-heading ml-4 textCap">
          <h2>{schoolDetails?.name}</h2>
        </div>

        <div className="mt-5">
          <h2>
            Teachers
            <Link onClick={handleShow}>
              <button className="btn btn-add-device float-right ">
                <i className="fas fa-plus-circle"></i> {"  "}
                <span> Invite New Teacher</span>
              </button>
            </Link>
            <Link onClick={() => newTeacherPopup.current.open()}>
              <button className="btn btn-add-device float-right ">
                <i className="fas fa-plus-circle"></i> {"  "}
                <span> Create New Teacher</span>
              </button>
            </Link>
          </h2>
        </div>
        <br />
        <div className="d-flex justify-content-between">
          <Box>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Teachers" {...a11yProps(0)} />
              <Tab label="Deleted Teachers" {...a11yProps(1)} />
            </Tabs>
          </Box>
          {value?
          <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          pageCount={noOfDelPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handleChangeDelPage}
          containerClassName="pagination"
          activeClassName="activePage active"
          forcePage={currDelPage}
        />
        :  <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={noOfPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handleChangePage}
              containerClassName="pagination"
              activeClassName="activePage active"
              forcePage={currPage}
            />}
         
        </div>
        <TabPanel value={value} index={0}>
          <Paper sx={{ width: "100%", mb: 2 }}>
            <EnhancedTableToolbar numSelected={selected.length} />
            <TableContainer sx={{height: "80vh",overflow: "auto" }}>
              <Table className="table">
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={tOrder}
                  orderBy={tOrderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={onSetOrder}
                  rowCount={teachers.length}
                />
                <TableBody>
                  {teachers
                    .map((data, index) => {
                      const isItemSelected = isSelected(data.name);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, data.name)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={data.name}
                          selected={isItemSelected}
                        >
                          <TableCell align="center">{data._id}</TableCell>
                          <TableCell align="center">
                            {data?.fName} {data?.lName}
                          </TableCell>
                          <TableCell align="center">
                            {data?.email === data._id
                              ? data?.emailF
                              : data.email}
                          </TableCell>
                          <TableCell align="center">
                            {data?.deleted ? (
                              <Typography>Removed</Typography>
                            ) : (
                              <div>
                                <Tooltip title="Device" placement="top">
                                  <Link
                                    className="mr-2"
                                    onClick={() => {
                                      prepareDeviceBox(data?._id);
                                      setTeacherId(data?._id);
                                      getAssignedDevicesForTeachers1(data?._id);
                                    }}
                                  >
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 22 22"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                    </svg>
                                  </Link>
                                </Tooltip>
                                <Tooltip title="Edit" placement="top">
                                  <Link
                                    onClick={() => {
                                      showEditModal(data?._id, data, "edit");
                                    }}
                                  >
                                    <i className="fas fa-edit icon-size-20"></i>
                                  </Link>
                                </Tooltip>
                                &nbsp;
                                <Tooltip title="Remove" placement="top">
                                  <Link
                                    onClick={() => {
                                      showEditModal(data?._id, data, "delete");
                                    }}
                                  >
                                    <i
                                      className="fas fa-trash-alt icon-size-20"
                                      style={{ color: "red" }}
                                    ></i>
                                  </Link>
                                </Tooltip>
                                &nbsp;
                                <Tooltip title="Mail Password" placement="top">
                                  <Link
                                    onClick={() => {
                                      passwordChange(data?._id, data?.email);
                                    }}
                                  >
                                    <i className="fa fa-key icon-size-20"></i>
                                  </Link>
                                </Tooltip>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: (dense ? 33 : 53) * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Paper sx={{ width: "100%", mb: 2 }}>
            <EnhancedTableToolbar numSelected={selected.length} />
            <TableContainer sx={{ height: "80vh", overflow: "auto" }}>
              <Table className="table">
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={delTOrder}
                  orderBy={delTOrderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={onSetOrder}
                  rowCount={deletedTeachers.length}
                />
                <TableBody>
                  {deletedTeachers
                    .map((data, index) => {
                      const isItemSelected = isSelected(data.name);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, data.name)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={data.name}
                          selected={isItemSelected}
                        >
                          <TableCell align="center">{data._id}</TableCell>
                          <TableCell align="center">
                            {data?.fName} {data?.lName}
                          </TableCell>
                          <TableCell align="center">
                            {data?.email === data._id
                              ? data?.emailF
                              : data.email}
                          </TableCell>
                          <TableCell align="center">
                            {" "}
                            {data?.deleted ? (
                              <Typography>Removed</Typography>
                            ) : (
                              <div>
                                <Tooltip title="Device" placement="top">
                                  <Link
                                    className="mr-2"
                                    onClick={() => {
                                      prepareDeviceBox(data?._id);
                                      setTeacherId(data?._id);
                                      getAssignedDevicesForTeachers1(data?._id);
                                    }}
                                  >
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 22 22"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                      <path
                                        d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z"
                                        fill="#495057"
                                        stroke="#495057"
                                        strokeWidth="0.6"
                                      />
                                    </svg>
                                  </Link>
                                </Tooltip>
                                <Tooltip title="Edit" placement="top">
                                  <Link
                                    onClick={() => {
                                      showEditModal(data?._id, data, "edit");
                                    }}
                                  >
                                    <i className="fas fa-edit icon-size-20"></i>
                                  </Link>
                                </Tooltip>
                                &nbsp;
                                <Tooltip title="Remove" placement="top">
                                  <Link
                                    onClick={() => {
                                      showEditModal(data?._id, data, "delete");
                                    }}
                                  >
                                    <i
                                      className="fas fa-trash-alt icon-size-20"
                                      style={{ color: "red" }}
                                    ></i>
                                  </Link>
                                </Tooltip>
                                &nbsp;
                                <Tooltip title="Mail Password" placement="top">
                                  <Link
                                    onClick={() => {
                                      passwordChange(data?._id, data?.email);
                                    }}
                                  >
                                    <i className="fa fa-key icon-size-20"></i>
                                  </Link>
                                </Tooltip>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRowsDelT > 0 && (
                    <TableRow
                      style={{
                        height: (dense ? 33 : 53) * emptyRowsDelT,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </TabPanel>
      </div>

      <Popup ref={newTeacherPopup}>
        <form
          className="form"
          onSubmit={(e) => {
            handleCreateFullNewTeacher(e);
          }}
        >
          <br />
          <h5>Create New Teacher </h5>
          <br />
          <input
            type="text"
            required
            placeholder="First Name"
            className="form-control form-input-2"
            onChange={(e) => {
              setDataNewTeacher({ ...dataNewTeacher, fName: e.target.value });
            }}
            onBlur={(e) => {
              setAdminTouched({ ...adminTouched, fName: true });
              setDataNewTeacher({
                ...dataNewTeacher,
                fName: e.target.value.trim(),
              });
            }}
            value={dataNewTeacher.fName}
          />
          {dataNewTeacher.fName.trim() == "" && adminTouched.fName ? (
            <span style={{ color: "red" }}>FirstName is required</span>
          ) : null}

          <input
            type="text"
            required
            placeholder="Last Name"
            className="form-control form-input-2"
            onChange={(e) => {
              setDataNewTeacher({ ...dataNewTeacher, lName: e.target.value });
            }}
            onBlur={(e) => {
              setAdminTouched({ ...adminTouched, lName: true });
              setDataNewTeacher({
                ...dataNewTeacher,
                lName: e.target.value.trim(),
              });
            }}
            value={dataNewTeacher.lName}
          />
          {dataNewTeacher.lName.trim() == "" && adminTouched.lName ? (
            <span style={{ color: "red" }}>LastName is required</span>
          ) : null}

          <input
            type="email"
            required
            placeholder="Email"
            className="form-control form-input-2"
            onChange={(e) => {
              setDataNewTeacher({ ...dataNewTeacher, email: e.target.value });
            }}
            onBlur={(e) => {
              setAdminTouched({ ...adminTouched, email: true });
              setDataNewTeacher({
                ...dataNewTeacher,
                email: e.target.value.trim(),
              });
            }}
            value={dataNewTeacher.email}
          />
          {dataNewTeacher.email.trim() == "" && adminTouched.email ? (
            <span style={{ color: "red" }}>Email is required</span>
          ) : !emailRegex.test(dataNewTeacher.email) &&
            dataNewTeacher.email.trim() != "" &&
            adminTouched.email ? (
            <span style={{ color: "red" }}>Email pattern is required</span>
          ) : null}

          <input
            type="text"
            placeholder="Password"
            className="form-control form-input-2"
            onChange={(e) => {
              setDataNewTeacher({
                ...dataNewTeacher,
                password: e.target.value,
              });
            }}
            onBlur={(e) => {
              setAdminTouched({ ...adminTouched, password: true });
              setDataNewTeacher({
                ...dataNewTeacher,
                password: e.target.value.trim(),
              });
            }}
            value={dataNewTeacher.password}
          />
          {dataNewTeacher.password.trim() == "" && adminTouched.password ? (
            <div style={{ color: "red" }}>Password is required</div>
          ) : null}

          <small style={{ color: "red" }}>
            Password should contain upto 8 characters
          </small>
          <br />
          <br />
          <input
            type="submit"
            value="Create"
            className="form-control submit-btn"
            disabled={!teacherValidation()}
          />
        </form>
      </Popup>

      <Snackbar
        open={snackBarShow}
        autoHideDuration={3000}
        onClose={SnackClose}
      >
        <Alert
          onClose={SnackClose}
          severity={snackBarSeverity}
          sx={{ width: "100%" }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </section>
  );
}

function TabPanel(props) {
  const { children, value, index, user, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
